const oneBoxJson = [{
  rules: [
  {
  name: "Red Hat Enterprise Linux",
  type: "product",
  description: "Red Hat® Enterprise Linux® provides core operating system functions and capabilities for application infrastructure.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-enterprise-linux/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/downloads/content/69/ver=/rhel---7/7.2/x86_64/product-software?onebox=y"
  },
  {
  text: "Errata",
  link: "https://access.redhat.com/downloads/content/69/ver=/rhel---7/7.2/x86_64/product-errata?onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-enterprise-linux/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-enterprise-linux?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-Enterprise-Linux"
  }
  ]
  },
  keywords: [
  "red hat enterprise",
  "rhel",
  "rhel2",
  "Rhel2.1",
  "Rhel2.2",
  "Rhel2.3",
  "Rhel2.4",
  "Rhel2.5",
  "Rhel2.6",
  "Rhel2.7",
  "rhel3",
  "Rhel3.1",
  "Rhel3.2",
  "Rhel3.3",
  "Rhel3.4",
  "Rhel3.5",
  "Rhel3.6",
  "Rhel3.7",
  "Rhel3.8",
  "Rhel3.9",
  "rhel4",
  "Rhel4.1",
  "Rhel4.2",
  "Rhel4.3",
  "Rhel4.4",
  "Rhel4.5",
  "Rhel4.6",
  "Rhel4.7",
  "Rhel4.8",
  "Rhel4.9",
  "rhel5",
  "Rhel5.1",
  "Rhel5.2",
  "Rhel5.3",
  "Rhel5.4",
  "Rhel5.5",
  "Rhel5.6",
  "Rhel5.7",
  "Rhel5.8",
  "Rhel5.9",
  "Rhel5.10",
  "Rhel5.11",
  "rhel6",
  "Rhel6.1",
  "Rhel6.2",
  "Rhel6.3",
  "Rhel6.4",
  "Rhel6.5",
  "Rhel6.6",
  "Rhel6.7",
  "rhel7",
  "Rhel7.1",
  "linux2",
  "linux2.1",
  "linux2.2",
  "linux2.3",
  "linux2.4",
  "linux2.5",
  "linux2.6",
  "linux2.7",
  "linux3",
  "linux3.1",
  "linux3.2",
  "linux3.3",
  "linux3.4",
  "linux3.5",
  "linux3.6",
  "linux3.7",
  "linux3.8",
  "linux3.9",
  "linux4",
  "linux4.1",
  "linux4.2",
  "linux4.3",
  "linux4.4",
  "linux4.5",
  "linux4.6",
  "linux4.7",
  "linux4.8",
  "linux4.9",
  "linux5",
  "linux5.1",
  "linux5.2",
  "linux5.3",
  "linux5.4",
  "linux5.5",
  "linux5.6",
  "linux5.7",
  "linux5.8",
  "linux5.9",
  "linux5.10",
  "linux5.11",
  "linux6",
  "linux6.1",
  "linux6.2",
  "linux6.3",
  "linux6.4",
  "linux6.5",
  "linux6.6",
  "linux6.7",
  "linux7",
  "linux7.1",
  "enterprise linux",
  "red hat linux",
  "redhat linux"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Virtualization",
  type: "product",
  description: "Red Hat Virtualization® is a complete open-source virtualization solution, derived from the Red Hat Enterprise Linux kernel, Kernel-based Virtual Machine (KVM) technology, and oVirt virtualization management projects.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-virtualization/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/downloads/content/150/ver=/rhel---7/7.2/x86_64/product-software?onebox=y"
  },
  {
  text: "Errata",
  link: "https://access.redhat.com/downloads/content/150/ver=/rhel---7/7.2/x86_64/product-errata?onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-virtualization/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-enterprise-virtualization/?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Cloud-Computing-Virtualization-and-Storage"
  }
  ]
  },
  keywords: [
  "rhev",
  "rhevm",
  "enterprise virtualization",
  "enterprise vert",
  "vert",
  "virt"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Identity Management",
  type: "product",
  description: "Identity Management in Red Hat Enterprise Linux® is designed and integrated into Red Hat Enterprise Linux for versions 6.2 and later, to simplify identity management.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/identity-management-and-infrastructure/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/downloads/content/rhel---7/x86_64/2456/ipa-server/4.1.0-18.el7_1.4/x86_64/fd431d51/package?onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-enterprise-linux/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/articles/1586893?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-Enterprise-Linux"
  }
  ]
  },
  keywords: [
  "identity",
  "red hat identity",
  "rhim"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Gluster Storage",
  type: "product",
  description: "Red Hat Gluster Storage (formerly Red Hat Storage Server) provides an open, software-defined storage solution across physical, virtual, and cloud resources. Founded on Red Hat Enterprise Linux and GlusterFS, Red Hat Gluster Storage combines file storage with a scaled-out architecture that lets you efficiently store and manage unstructured data, providing cost-effective and highly available storage without compromising on scale or performance.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-storage/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/downloads/content/186/ver=3.1/rhel---7/3.1/x86_64/product-software?onebox=y"
  },
  {
  text: "Errata",
  link: "https://access.redhat.com/downloads/content/186/ver=3.1/rhel---7/3.1/x86_64/product-errata?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-storage/?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Cloud-Computing-Virtualization-and-Storage"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Cloud-Computing-Virtualization-and-Storage"
  }
  ]
  },
  keywords: [
  "storage",
  "redhat storage",
  "docker storage",
  "gluster storage"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat CloudForms",
  type: "product",
  description: "Red Hat® CloudForms manages private clouds, virtual environments, and public clouds in a single tool. Want to learn more?",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-cloudforms/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/downloads/content/167/?onebox=y"
  },
  {
  text: "Errata",
  link: "https://access.redhat.com/downloads/content/167/ver=/cf-me---4.0/4.0/x86_64/product-errata?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-cloudforms/?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Cloud-Computing-Virtualization-and-Storage"
  }
  ]
  },
  keywords: [
  "cloudforms",
  "cloud forms"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat OpenStack Platform",
  type: "product",
  description: "Red Hat OpenStack Platform delivers an integrated foundation to create, deploy, and scale a secure and reliable public or private OpenStack cloud. Red Hat OpenStack Platform combines the world's leading enterprise Linux and the fastest-growing cloud infrastructure platform to give you the agility to scale and quickly meet customer demands without compromising on availability, security, or performance.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-openstack-platform/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/products/red-hat-enterprise-linux-openstack-platform/?onebox=y"
  },
  {
  text: "Try",
  link: "http://www.redhat.com/openstack/evaluation/?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/red_hat_openstack_platform/"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-OpenStack-Platform"
  }
  ]
  },
  keywords: [
  "openstack",
  "open stack",
  "redhat openstack",
  "redhat open stack",
  "enterprise openstack",
  "enterprise open stack",
  "linux openstack"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat OpenShift Container Platform",
  type: "product",
  description: "Built on Red Hat® Enterprise Linux® and Google Kubernetes, OpenShift Container Platform provides a secure and scalable multi-tenant operating system for today’s enterprise-class applications.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-openshift-container-platform?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/products/red-hat-openshift-container-platform/#getstarted?onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-openshift-container-platform/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/openshift_container_platform/"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#OpenShift"
  },
  {
  text: "Labs",
  link: "https://access.redhat.com/labs/oia/"
  }
  ]
  },
  keywords: [
  "openshift",
  "open shift",
  "redhat openshift",
  "redhat open shift",
  "openshift enterprise",
  "open shift enterprise"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat JBoss EAP",
  type: "product",
  description: "Red Hat® JBoss® Enterprise Application Platform is a middleware platform built on open standards and compliant with the Java Enterprise Edition specification.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-jboss-enterprise-application-platform/?onebox=y"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/jbossnetwork/restricted/listSoftware.html?product=appplatform&downloadType=distributions&onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-jboss-enterprise-application-platform/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/jboss-enterprise-application-platform?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Enterprise-Application-Platform-EAP"
  }
  ]
  },
  keywords: [
  "eap",
  "jboss",
  "jboss eap",
  "enterprise application platform"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Mobile Application Platform",
  type: "product",
  description: "Red Hat Mobile Application Platform (formerly FeedHenry) brings agility, visibility and efficiency to enterprise mobility. Our Mobile App Platform embraces collaborative app development across multiple teams and projects and supports development 'your way' with Bring-Your-Own-Tools (BYOT). It offers centralized control of security as well as API and Enterprise MBaaS integration plus a choice of cloud deployment options.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-mobile-application-platform?onebox=y"
  },
  {
  text: "Documentation",
  link: "http://docs.feedhenry.com/v3/index.html?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Fuse-BRMS-and-more"
  }
  ]
  },
  keywords: [
  "feedhenry",
  "feed henry",
  "mobile",
  "mobile application",
  "mobile platform",
  "redhat mobile",
  "redhat feedhenry",
  "red hat mobile",
  "red hat feed henry",
  "red hat feedhenry"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Fuse",
  type: "product",
  description: "Red Hat Fuse is an open source, lightweight Enterprise Service Bus (ESB). It delivers a robust, cost-effective, and modular integration platform that lets enterprises easily connect their disparate applications, services, or devices in real time. An integrated enterprise is able to provide better products and innovative services to its customers. A flexible architecture coupled with popular and proven integration tools enables Red Hat Fuse to integrate everything, everywhere.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-fuse"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/jbossnetwork/restricted/listSoftware.html?product=jboss.fuse&downloadType=distributions&onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-jboss-fuse/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-US/Red_Hat_Fuse/?onebox="
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Fuse-BRMS-and-more"
  }
  ]
  },
  keywords: [
  "fuse",
  "jboss fuse",
  "redhat fuse",
  "red hat fuse"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Process Automation Manager",
  type: "product",
  description: "Red Hat Process Automation Manager is a comprehensive platform for business process management that can be deployed across physical, virtual, mobile, and cloud environments. It includes all the business rules and complex event processing (CEP) capabilities of Red Hat JBoss BRMS plus advanced tools and runtime support for Business Process Model and Notation v2.0 (BPMN2)-compliant business processes.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-process-automation-manager"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/jbossnetwork/restricted/listSoftware.html?downloadType=distributions&product=rhpam&productChanged=yes&onebox=y"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/site/products/red-hat-jboss-bpm-suite/evaluation?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/red_hat_process_automation_manager"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#DevOps"
  }
  ]
  },
  keywords: [
  "jboss bpm",
  "redhat bpm",
  "red hat bpm",
  "business process management",
  "jboss business",
  "jbossbpm",
  "process automation",
  "automation manager",
  "rhpam"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat Decision Manager",
  type: "product",
  description: "Red Hat Decision Manager is a comprehensive platform for business rules management and complex event processing. Organizations can incorporate sophisticated decision logic into line-of-business applications and quickly update underlying business rules as market conditions change.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/rs/products/red-hat-decision-manager"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/jbossnetwork/restricted/listSoftware.html?product=rhdm&downloadType=distributions"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-decision-manager/evaluation"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/search/#/?q=decision%20manager&p=1&sort=relevant&scoped&product=Red%20Hat%20Decision%20Manager&language=en&documentKind=Documentation"
  },
  {
  text: "Solution",
  link: "https://access.redhat.com/search/#/?q=decision%20manager&p=1&sort=relevant&scoped=false&documentKind=Knowledgebase&product=Red%20Hat%20JBoss%20BRMS&language=en"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Fuse-BRMS-and-more"
  }
  ]
  },
  keywords: [
  "brms",
  "jbossbrms",
  "business rules management",
  "redhat brms",
  "red hat brms",
  "decison manager",
  "decision manager"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat JBoss Core Services Collection",
  type: "product",
  description: "Red Hat JBoss Core Services Collection provides components that increase the value of JBoss Middleware products by enhancing manageability, security, scalability, and interoperability",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/collections/red-hat-jboss-core-services-collection?onebox=y"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-jboss-core-services/?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Fuse-BRMS-and-more"
  }
  ]
  },
  keywords: [
  "operations network",
  "apache http",
  "jsvc",
  "web connectors",
  "jon",
  "http"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Red Hat AMQ",
  type: "product",
  description: "Red Hat AMQ 7 provides fast, lightweight, and secure messaging for Internet-scale applications. Red Hat AMQ 7 components use industry-standard message protocols and support a wide range of programming languages and operating environments.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-amq"
  },
  {
  text: "Downloads",
  link: "https://access.redhat.com/jbossnetwork/restricted/listSoftware.html?product=jboss.amq.broker"
  },
  {
  text: "Try",
  link: "https://access.redhat.com/products/red-hat-jboss-amq/evaluation?onebox=y"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Red-Hat-JBoss-Fuse-BRMS-and-more"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/red_hat_amq?onebox=y"
  }
  ]
  },
  keywords: [
  "amq",
  "messaging",
  "a-mq"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "The Answer to Life, the Universe and Everything is 42",
  type: "product",
  description: "Millenia ago the universe's cleverest philosophers commissioned pan-dimensional beings to find the answer to life, the universe and everything. These beings built Deep Thought, a massive computer, giving it the question to ponder. 7.5 Million years later, Deep Thought answered '42'. Realizing no one knew what the question was, they commissioned another computer now known as 'earth'. Results are pending. As long as no one builds a hyperspace express route, we should all know the answer soon.",
  links: {
  info: [
  {
  text: "Documentation",
  link: "https://en.wikipedia.org/wiki/The_Hitchhiker%27s_Guide_to_the_Galaxy"
  }
  ]
  },
  keywords: [
  "life universe everything",
  "what is the answer to life the universe and everything"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Blueborne Vulnerability",
  type: "vulnerability",
  description: "A stack buffer overflow issue was found in the way the Linux kernel's Bluetooth subsystem processed the pending configuration packets received from a client. This could allow a client to send and execute arbitrary L2CAP configuration parameters.",
  links: {
  info: [
  {
  text: "Vulnerability",
  link: "https://access.redhat.com/security/vulnerabilities/blueborne"
  },
  {
  text: "Solution",
  link: "https://access.redhat.com/solutions/3177231"
  },
  {
  text: "Overview",
  link: "https://access.redhat.com/blogs/product-security/posts/blueborne"
  }
  ]
  },
  keywords: [
  "blueborne",
  "bluetooth",
  "cve-2017-1000251",
  "cve 1000251",
  "1000251",
  "l2cap",
  "blue born"
  ],
  additional_info: {
  common_name: "Blueborne",
  severity: "Important Impact",
  cves: [
  "CVE-2017-1000251"
  ]
  }
  },
  {
  name: "Kernel ELF Vulnerability",
  type: "vulnerability",
  description: "Red Hat Product Security has been made aware of a vulnerability rated IMPORTANT in Linux kernel ELF Loader that affects Red Hat Enterprise Linux versions prior to 7.4.0. Details can be found in following links.",
  links: { },
  keywords: [
  "elf",
  "pie",
  "cve-2017-1000253",
  "cve 1000253",
  "1000253",
  "stack corruption",
  "elf binary",
  "qualys"
  ],
  additional_info: {
  common_name: "",
  severity: "Important Impact",
  cves: [
  "CVE-2017-1000253"
  ]
  }
  },
  {
  name: "Meltdown and Spectre Vulnerabilities",
  type: "vulnerability",
  description: "Red Hat Product Security has been made aware of a vulnerability rated LOW. The Kernel Side-Channel Attack vulnerability can result in an unprivileged attacker obtaining read access to privileged memory. It is critical to address this issue.",
  links: {
  info: [
  {
  text: "Vulnerability",
  link: "https://access.redhat.com/security/vulnerabilities/speculativeexecution"
  },
  {
  text: "Labs",
  link: "https://access.redhat.com/labsinfo/speculativeexecution"
  }
  ]
  },
  keywords: [
  "cve-2017-5753",
  "cve-2017-5715",
  "cve-2017-5754",
  "2017-5753",
  "2017-5715",
  "2017-5754",
  "5753",
  "5715",
  "5754",
  "kernel side",
  "tomasulo",
  "out of order execution",
  "cache side",
  "conditional branch",
  "indirect branch",
  "speculative load",
  "kaiser",
  "kpti",
  "pti",
  "meltdown",
  "melt down",
  "spectre"
  ],
  additional_info: {
  common_name: "",
  severity: "Important Impact",
  cves: [
  "cve-2017-5753",
  "cve-2017-5715",
  "cve-2017-5754"
  ]
  }
  },
  {
  name: "dnsmasq Vulnerabilities",
  type: "vulnerability",
  description: "Red Hat Product Security has been made aware of a vulnerability rated CRITICAL. Multiple vulnerabilities have been found in dnsmasq that could cause system crashes or malicious code execution.",
  links: { },
  keywords: [
  "dnsmasq",
  "cache resolver",
  "cve-2017-14491",
  "cve 14491",
  "14491",
  "cve-2017-14492",
  "cve 14492",
  "14492",
  "cve-2017-14493",
  "cve 14493",
  "14493",
  "cve-2017-14494",
  "cve 14494",
  "14494",
  "cve-2017-14495",
  "cve 14495",
  "14495",
  "cve-2017-14496",
  "cve 14496",
  "14496",
  "cve-2017-13704",
  "cve 13704",
  "13704",
  "lightweight dns",
  "lightweight dhcp",
  "add-mac",
  "add-cpe-id",
  "add-subnet",
  "google security"
  ],
  additional_info: {
  common_name: "",
  severity: "Critical Impact",
  cves: [
  "cve-2017-14491",
  "cve-2017-14492",
  "cve-2017-14493",
  "cve-2017-14494",
  "cve-2017-14495",
  "cve-2017-14496",
  "cve-2017-13704"
  ]
  }
  },
  {
  name: "OpenShift.io",
  type: "product",
  description: "Red Hat OpenShift.io is an end-to-end development environment for planning, creating and deploying hybrid cloud services. It extends the developer features of Red Hat OpenShift Online, a cloud-based container platform that enables developers to build, deploy, host and scale container-based applications.",
  links: { },
  keywords: [
  "openshift.io",
  "osio",
  "openshiftio"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Kernel Side-Channel Attack using Speculative Store Bypass",
  type: "vulnerability",
  description: "This vulnerability exists in modern microprocessors, requiring updates to the Linux kernel, virtualization-related components, and a microcode update. An unprivileged attacker can use this flaw to bypass restrictions in order to gain read access to privileged memory that would otherwise be inaccessible.",
  links: {
  info: [
  {
  text: "Vulnerability",
  link: "https://access.redhat.com/security/vulnerabilities/ssbd"
  }
  ]
  },
  keywords: [
  "cve-2018-3639",
  "2018-3639",
  "3639",
  "kernel side channel",
  "speculative store",
  "microcode_ctl",
  "memory disambiguation",
  "ssbd",
  "variant 4",
  "spectre ng",
  "spectre next generation"
  ],
  additional_info: {
  common_name: "",
  severity: "Important Impact",
  cves: [
  "cve-2018-3639"
  ]
  }
  },
  {
  name: "Red Hat Cloud Infrastructure",
  type: "product_suite",
  description: "Red Hat® Cloud Infrastructure is a combination of tightly integrated Red Hat technologies that lets you build and manage an open, private Infrastructure-as-a-Service (IaaS) cloud.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-cloud-infrastructure"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-US/Red_Hat_Cloud_Infrastructure/"
  },
  {
  text: "Solution",
  link: "https://access.redhat.com/search/#/?q=red%20hat%20cloud%20infrastructure&p=1&sort=relevant&scoped&documentKind=Knowledgebase&product=Red%20Hat%20Cloud%20Infrastructure&language=en"
  },
  {
  text: "Video",
  link: "https://access.redhat.com/search/#/?q=red%20hat%20cloud%20infrastructure&p=1&sort=relevant&scoped=false&documentKind=Video&product=Red%20Hat%20Cloud%20Infrastructure&language=en"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#Cloud-Computing-Virtualization-and-Storage"
  }
  ]
  },
  keywords: [
  "rhci",
  "cloud infrastructure",
  "iaas",
  "open infrastructure",
  "private cloud",
  "red hat cloud",
  "cloud infrastructure"
  ],
  additional_info: {
  products: [
  {
  product_name: "Red Hat OpenStack",
  page_link: "https://access.redhat.com/products/red-hat-openstack-platform/"
  },
  {
  product_name: "Red Hat Virtualization",
  page_link: "https://access.redhat.com/products/red-hat-enterprise-virtualization/"
  },
  {
  product_name: "Red Hat CloudForms",
  page_link: "https://access.redhat.com/products/red-hat-cloudforms/"
  },
  {
  product_name: "Red Hat Satellite",
  page_link: "https://access.redhat.com/products/red-hat-satellite/"
  },
  {
  product_name: "Red Hat Insights",
  page_link: "https://access.redhat.com/products/red-hat-insights/"
  },
  {
  product_name: "Red Hat Ceph Storage",
  page_link: "https://access.redhat.com/products/red-hat-ceph-storage/"
  }
  ]
  }
  },
  {
  name: "Red Hat 3scale API Management",
  type: "product",
  description: "Red Hat® 3scale API Management makes it easy to manage your APIs. Share, secure, distribute, control, and monetize your APIs on an infrastructure platform built for performance, customer control, and future growth. ",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-3scale"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en/red-hat-3scale/"
  },
  {
  text: "Try",
  link: "https://www.3scale.net/signup/"
  },
  {
  text: "Solution",
  link: "https://access.redhat.com/search/#/?q=&p=1&sort=relevant&scoped&documentKind=Knowledgebase&language=en"
  },
  {
  text: "Discussions",
  link: "https://access.redhat.com/search/#/?q=3scale&p=1&sort=relevant&scoped=false&documentKind=Discussion&language=en"
  }
  ]
  },
  keywords: [
  "3scale",
  "api management",
  "traffic control",
  "gateway control",
  "access control",
  "rate limits",
  "apicast",
  "amp"
  ],
  additional_info: {
  subtitle: ""
  }
  },
  {
  name: "Network Teaming Helper",
  type: "product",
  description: "This app is designed to help you configure network teaming. It has two modes: guided mode and manual mode . The guided mode requires minimum input of information. The manual mode allows for greater control & customization of parameters.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/labsinfo/teamdconfighelper"
  },
  {
  text: "Labs",
  link: "https://access.redhat.com/labs/teamdconfighelper/"
  }
  ]
  },
  keywords: [
  "network teaming",
  "teaming",
  "teamd",
  "network bonding"
  ],
  additional_info: {
  subtitle: "A Red Hat Labs Application to Configure Network Teaming"
  }
  },
  {
  name: "Red Hat Ansible Tower",
  type: "product",
  description: "Red Hat Ansible Tower is a simple IT automation engine that automates cloud provisioning, configuration, deployment, and orchestration.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/ansible-tower-red-hat"
  },
  {
  text: "Downloads",
  link: "https://www.ansible.com/tower-trial"
  },
  {
  text: "Try",
  link: "https://www.ansible.com/contact-us"
  },
  {
  text: "Documentation",
  link: "http://docs.ansible.com/ansible-tower"
  },
  {
  text: "Training",
  link: "https://www.redhat.com/en/services/training/courses-by-curriculum#DevOps"
  }
  ]
  },
  keywords: [
  "ansible"
  ],
  additional_info: {
  subtitle: "Automate Apps and IT infrastructure."
  }
  },
  {
  name: "L1 Terminal Fault Attack",
  type: "vulnerability",
  description: "This vulnerability identifies an issue where unprivileged attackers can use this flaw to bypass memory security restrictions in order to gain access to data stored in memory that would otherwise be inaccessible.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://www.redhat.com/en/blog/understanding-l1-terminal-fault-aka-foreshadow-what-you-need-know"
  },
  {
  text: "Vulnerability",
  link: "https://access.redhat.com/security/vulnerabilities/L1TF"
  },
  {
  text: "Labs",
  link: "https://access.redhat.com/labs/l1tf/"
  },
  {
  text: "Ansible",
  link: "https://access.redhat.com/articles/3569281"
  }
  ]
  },
  keywords: [
  "3620",
  "3646",
  "terminal fault",
  "fault attack",
  "foreshadow",
  "cache flush",
  "hyperthreading",
  "multithreading",
  "side channel"
  ],
  additional_info: {
  common_name: "Foreshadow",
  cves: [
  "CVE-2018-3646",
  "CVE-2018-3620"
  ],
  severity: "Important Impact"
  }
  },
  {
  name: "Red Hat CodeReady Workspaces",
  type: "product",
  description: "Red Hat® CodeReady Workspaces for OpenShift provides a container-based, cloud-native, in-browser IDE for rapid, decentralized development with portable runtimes.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-codeready-workspaces-for-openshift/"
  },
  {
  text: "Try",
  link: "https://che.openshift.io/"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/red_hat_codeready_workspaces_for_openshift/"
  },
  {
  text: "Discussions",
  link: "https://access.redhat.com/discussions?product=%3CPRODUCT_ID%3E&category=All&tags=All"
  },
  {
  text: "Downloads",
  link: "https://developers.redhat.com/download-manager/file/codeready-workspaces-apb-installer-1.0.0.Beta1.tar.gz"
  }
  ]
  },
  keywords: [
  "codeready",
  "workspaces",
  "ide",
  "code ready",
  "work spaces"
  ],
  additional_info: {
  subtitle: "Version 1.0.0 Beta"
  }
  },
  {
  name: "Red Hat OpenShift Data Foundation",
  type: "product_suite",
  description: "Storage for hybrid cloud and multicloud container deployments.Red Hat OpenShift Data Foundation—previously Red Hat OpenShift Container Storage—is software-defined storage for containers to help teams develop and deploy applications quickly and efficiently across clouds.",
  links: {
  info: [
  {
  text: "Overview",
  link: "https://access.redhat.com/products/red-hat-openshift-data-foundation"
  },
  {
  text: "Documentation",
  link: "https://access.redhat.com/documentation/en-us/red_hat_openshift_data_foundation/"
  }
  ]
  },
  keywords: [
  "data foundation",
  "data platform",
  "openshift data",
  "openshift foundation",
  "openshift platform"
  ],
  additional_info: {
  products: [
  {
  product_name: "Red Hat Enterprise Linux",
  page_link: "https://access.redhat.com/products/red-hat-enterprise-linux/"
  },
  {
  product_name: "Red Hat OpenShift",
  page_link: "https://access.redhat.com/products/openshift"
  },
  {
  product_name: "Red Hat Ansible Automation Platform",
  page_link: "https://access.redhat.com/products/red-hat-ansible-automation-platform/"
  }
  ]
  }
  }
  ]
  }]

  module.exports = oneBoxJson